import React from 'react';

interface DateTimePickerProps {
  date: string;
  time: string;
  arriveBy: boolean;
  setDate: (d: string) => void;
  setTime: (t: string) => void;
  setArriveBy: (a: boolean) => void;
}

export default function DateTimePicker({ date, time, arriveBy, setDate, setTime, setArriveBy }: DateTimePickerProps) {
  return (
    <div className="datetime-picker">
      <div className="datetime-row">
        <select value={arriveBy ? 'arrive' : 'depart'} onChange={(e) => setArriveBy(e.target.value === 'arrive')}>
          <option value="depart">Depart at</option>
          <option value="arrive">Arrive by</option>
        </select>
        <input type="date" value={date} onChange={(e) => setDate(e.target.value)} />
        <input type="time" value={time} onChange={(e) => setTime(e.target.value)} />
      </div>
    </div>
  );
}
